<template>
  <!--  v-if="['external'].includes(route.name)" -->
  <div id="app">
    <router-view v-slot="{ Component }">
      <keep-alive :include="['external']">
        <component :is="Component" />
      </keep-alive>
    </router-view>
  </div>
</template>

<script setup>
import { useRoute } from "vue-router";

const route = useRoute();
</script>


<style lang="scss">
@import "./assets/scss/common.scss";
* {
  margin: 0;
  padding: 0;
  font-family: "\5FAE\8F6F\96C5\9ED1";
}

html,
body {
  overflow-x: hidden;
}

a {
  text-decoration: none;
}

input {
  background-color: transparent;
  border: none;
  outline: none;
}

select {
  border: none;
  background-color: transparent;
}

li {
  list-style: none;
}

.desktop {
  font-size: 100px;
  > body {
    font-size: 16px;
  }
}

.mobile {
  font-size: 15.625vw;
  background-color: #f1f2f3;

  * {
    outline: 0;
    -webkit-text-size-adjust: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-appearance: none;
    /*消除输入框和按钮的原生外观*/
  }

  > body {
    font-size: 20px;
  }

  .el-message {
    transform: translateX(-50%) scale(1.6);
  }

  input,
  textarea {
    font-size: 20px;
  }
}

input,
textarea {
  outline: none;
}

.clearfix:after {
  display: block;
  clear: both;
  content: "";
  visibility: hidden;
  height: 0;
}

.clearfix {
  zoom: 1;
}

.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.btn {
  background: linear-gradient(153deg, #00c0ec 0%, #5485f2 100%);
  cursor: pointer;
  color: #fff;
}
.btn-grey {
  background: linear-gradient(153deg, #00c0ec 0%, #5485f2 100%);
  opacity: 0.5;
  color: #fff;
}
.btn-red {
  background: linear-gradient(153deg, #00c0ec 0%, #5485f2 100%);
  cursor: pointer;
  color: #fff;
}

.line-btn {
  border: 1px solid #ddd;
  color: #606266;
}
</style>
